import { CloseButton, Col, Modal, Row, Form, Badge, Stack } from "react-bootstrap";
import { TextButton } from "Components/Button";
import { useDispatch } from "react-redux";
import { useEffect, useReducer, useState } from "react";
import { useRef } from "react";
import { formInfoReducer, ACTIONS } from "../../WebServiceFormDataReducer";
import { loadFormInfo, submitCreateWSAccount } from "../../WebServiceAxiosFuncs";
import { store } from 'Store';
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import { FormTextInput } from "Components/Forms/FormInput";
import { STATUSES, ERROR_MESSAGES } from "Utils/constants";
import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';

const nameConverter = {
  "selectedPSOOrg": "selectedPSOOrg",
  "status": "orgStatus"
}

const CreateWebServiceAccountPopup = ({
  show,
  handleClose,
  refresh,
  setReloadListWebServiceAccount
}) => {

  const dispatch = useDispatch();
  const loginState = store.getState().loginInfo;
  const token = "Bearer " + loginState.token;

  const initialState = {
    data: '',
    loading: true,
    error: null,
  };

  const [formInfo, formInfoDispatch] = useReducer(formInfoReducer, initialState);
  const formFieldDisplay = {
    selectedPSOOrg: {
      type: 'select',
      id: 'selectedPSOOrg',
      name: 'selectedPSOOrg',
      display: {
        label: 'Organization',
        description: "",
        title: "",
      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    orgStatus: {
      type: 'radio',
      id: 'orgStatus',
      name: 'orgStatus',
      display: {
        label: 'Account Status',
        description: ""
      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)

    }
  }

  var psoOrgListValues = (psoOrgList) => {
    var objArr = [];
    objArr.push({
      index: 0,
      value: null,
      title: null,
      displayValue: "Please Select",
      isSelected: true
    });

    for (var i = 0; i < psoOrgList.length; i++) {
      var x = psoOrgList[i];
      objArr.push({
        index: x.orgId,
        value: x.orgId + "_" + x.psoId,
        title: "Select Organization " + x.orgName,
        displayValue: x.orgName + " (" + x.psoId + ")",
        isSelected: false
      });
    }

    return objArr;
  }

  const handleSelectChange = (e) => {
    formInfoDispatch({
      type: ACTIONS.SELECT_CHANGE,
      value: e.target.value,
      name: e.target.name
    })
  }

  const handleRadioChange = (e) => {
    formInfoDispatch({
      type: ACTIONS.RADIO_CHANGE,
      value: e.target.value,
      name: e.target.name
    })
  }

  useEffect(() => {
    loadFormInfo(ACTIONS, formInfoDispatch, handleSelectChange, handleRadioChange, { psoOrgListValues }, token)
      .catch(function (error) {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: error.data ? error.data.data : ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
      });
  }, [refresh]);

  var dispErrors = (fieldName) => {
    var data = formInfo.data[fieldName];
    var dispData = formFieldDisplay[fieldName];
    return (
      <div>
        {data.validation.errors.length > 0 ? data.validation.errors.map((errorText, index) =>
          <Stack key={dispData.name + "Errors_" + index} direction="horizontal" gap={2} className="align-items-start">
            <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
            <div>{errorText}</div>
          </Stack>

        ) : null}
      </div>
    );
  }

  var dispLabel = (fieldName, isHidden, getColLabelSizes, alignment, multi) => {

    var data = formInfo.data[fieldName];
    var dispData = formFieldDisplay[fieldName];

    //console.log("print out data, dispData, fieldName", data, dispData, fieldName);

    if (alignment == Row) {
      if (multi == true) {
        return (
          <Col hidden={isHidden}
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            <legend>
              {<span className="me-2">{dispData.display.label}</span>}
              {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
            </legend>
          </Col>
        );
      }
      else {
        return (
          <Form.Label visuallyHidden={isHidden} column
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            {<span className="me-2">{dispData.display.label}</span>}
            {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
          </Form.Label>
        );
      }
    }
    else {
      if (multi == true) {
        return (
          <Row hidden={isHidden}
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            <legend>
              {dispData.display.label}
              {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
            </legend>
          </Row>
        );
      }
      else {
        return (
          <Form.Label visuallyHidden={isHidden}
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            {dispData.display.label}
            {data.validation.required ? '' : /*<span className="optionalField"><br></br>optional</span>*/ <Badge bg="optional">Optional</Badge>}
          </Form.Label>
        );
      }

    }

  };

  // close popup and reset form 
  const cancel = () => {
    loadFormInfo(ACTIONS, formInfoDispatch, handleSelectChange, handleRadioChange, { psoOrgListValues }, token);
    handleClose();
  }

  function getFieldValue (fieldName, data) {
    var values = data[fieldName];
    var dispValues = formFieldDisplay[fieldName];

    if (formInfo.loading) {
      return '';
    }
    else {
      var type = dispValues.type;
      switch (type) {

        case "select":
          if (values != null) {
            var arr = values.options;
            for (var x = 0; x < arr.length; x++) {
              var val = arr[x];
              if (val.isSelected) {
                return val.value;
              }
            }
          }
          return null;
        case "radio":
          if (values != null) {
            var arr = values.radioButtons;
            for (var x = 0; x < arr.length; x++) {
              if (arr[x].isChecked) {
                return arr[x].value;
              }
            }
          }
          return null;
      }
    }

  }

  function addErrorMessages (fieldName, errorFieldName, data, isFirst) {
    var d = data.fieldErrors;
    var values = d[errorFieldName];

    if (values != null) {
      var field = formFieldDisplay[fieldName];
      var type = field.type;
      var err = values.errorMessages;

      if (isFirst == true) {
        (field.InputRef).current.focus();
        //console.log("ISFIRST");
      }

      switch (type) {
        case "select":
          formInfoDispatch({
            type: ACTIONS.SELECT_SET_ERRORS,
            name: fieldName,
            errors: err
          })
          break;
        case "radio":
          formInfoDispatch({
            type: ACTIONS.RADIO_SET_ERRORS,
            name: fieldName,
            errors: err
          })
          break;
      }

    }
  }

  function clearErrorMessages (data) {
    for (const [key, value] of Object.entries(data)) {
      var t = formFieldDisplay[key];
      var fieldName = key;
      switch (t.type) {
        case "select":
          formInfoDispatch({
            type: ACTIONS.SELECT_REMOVE_ERRORS,
            name: fieldName
          })
          break;
        case "radio":
          formInfoDispatch({
            type: ACTIONS.RADIO_REMOVE_ERRORS,
            name: fieldName
          })
          break;
      }
    }
  }

  const handleSubmit = async () => {
    var result = await submitCreateWSAccount(token, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue)
      .then((res) => {
        if (res !== null && res !== undefined) {
          //console.log("submitCreateWSAccount", res);
          var statusCode = res.data.status;
          switch (statusCode) {
            case STATUSES.ERROR.code:
              if (res.data.globalErrorMessageList && res.data.globalErrorMessageList.length != 0) {
                setGlobalErrorStatus({
                  dispatch: dispatch,
                  popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: res.data.globalErrorMessageList,
                    showContactHelp: true
                  },
                  redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                  }
                })
              };
              break;
            case STATUSES.SUCCESS.code:
              loadFormInfo(ACTIONS, formInfoDispatch, handleSelectChange, handleRadioChange, { psoOrgListValues }, token);
              handleClose();
              // reload web service list datatable
              setReloadListWebServiceAccount(true);
              setGlobalSuccessStatus({
                dispatch: dispatch,
                popupData: {
                  visible: true,
                  title: "Success!",
                  msg: res.data.message,
                  showContactHelp: false
                },
                redirect: {
                  redirect: true,
                  redirectFirst: true,
                  path: "/manage/wsa",
                  data: {}
                }
              });
              setTimeout(function () {
                setReloadListWebServiceAccount(true);
              }, 1000);
              break;

          }
        }
      })
  }


  return (
    <>
      {formInfo.loading ? null :
        <Modal className="modal" size="lg" backdrop="static" show={show} centered>
          <Modal.Header className="ps-5 pe-5 pt-5">
            <Modal.Title>
              <div className="pb-3 mb-3"><CloseButton className="closeup-popup-button" onClick={cancel} /></div>
              <h1 className="header1 text-start">Create Web Service Account</h1>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-4 pb-5 ps-5 pe-5">
            <Form>
              <FormTextInput orgType={"Admin"} fieldName="selectedPSOOrg" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 4, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
              <br />
              <FormTextInput orgType={"Admin"} fieldName="orgStatus" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 4, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
              <Stack className="pt-3" direction="horizontal" gap={3}>
                {/* Submit Button */}
                <TextButton
                  variant="normal"
                  onClick={handleSubmit}
                  content={"Submit"}
                >
                </TextButton>
                {/* Cancel Button */}
                <TextButton
                  variant="outline"
                  onClick={cancel}
                  content={"Cancel"}
                >
                </TextButton>
              </Stack>
            </Form>
          </Modal.Body>
        </Modal>}
    </>
  )



}

export default CreateWebServiceAccountPopup;

